import './SessionNote.scss';

import { Affix } from 'antd';
import React from 'react';
import * as api from '@stores/api';

const noteGroup = [
  { title: 'Available', className: 'available' },
  { title: 'On-demand', className: 'on-demand' },
];

const noteItems = [
  { label: 'In-person Only', className: 'inperson' },
  { label: 'Video Only', className: 'video' },
  { label: 'In-person or Video', className: 'both' },
];

function SessionNote() {
  // const getTimezone = () => {
  //   const leadZero = num => (num < 11 ? '0' + num : num);

  //   const tzOffset = -1 * new Date().getTimezoneOffset();
  //   const hour = ~~Math.abs(tzOffset / 60);
  //   const minute = Math.abs(tzOffset % 60);

  //   return `UTC${tzOffset < 0 ? '-' : '+'}${leadZero(hour)}:${leadZero(
  //     minute,
  //   )}`;
  // };

  return (
    <Affix offsetTop={56.25} className="Session-affix">
      <div className="Session-note-container py-1">
        {noteGroup.map(({ title, className: c1 }, i) => (
          <div className="Session-note-group" key={title}>
            {title === 'Available' && (
              <div className="Session-note-item booked">
                <span
                  className="Session-note-title"
                  style={{
                    lineHeight: 1,
                    fontSize: '1em',
                    letterSpacing: '0.2px',
                    marginRight: '7px',
                    color: '#000'
                  }}
                >
              </span>
                <div
                  className="Session-note-background"
                  style={{ background: '#ffffff' }}
                />
              </div>
            )}
            {title === 'On-demand' && (
              <div className="Session-note-item booked">
                <span
                  className="Session-note-title"
                  style={{
                    lineHeight: 1,
                    fontSize: '1em',
                    letterSpacing: '0.2px',
                    marginRight: '7px',
                    color: '#000'
                  }}
                >
                  Reserved
              </span>
                <div
                  className="Session-note-background"
                  style={{ background: '#1FC0DA' }}
                />
              </div>
            )}

            <h4 className="Session-note-title">{title}:</h4>
            {noteItems.map(({ label, className: c2 }, idx) => (
              <div key={idx} className={`Session-note-item ${c1} ${c2}`}>
                <label className="Session-note-label">{label}</label>
                <div className="Session-note-background" />
              </div>
            ))}
            {!api.isCaseManager() &&
              <div className="Session-note-item booked">
                <label className="Session-note-label">Booked:</label>
                <div
                  className="Session-note-background"
                  style={i ? { background: '#ff7373' } : {}}
                />
              </div>
            }
          </div>
        ))}
        {/* <div className="Session-note-group note">
          <h4 className="Session-note-title">Note:</h4>
          <span>Session time displays in timezone {getTimezone()}</span>
        </div> */}
      </div>
    </Affix>
  );
}

export default SessionNote;
